// src/config.js

import * as PRICING from "./config/pricing";

const config = {
  API_BASE_URL: "http://127.0.0.1:8000",
  // API_BASE_URL: "http://15.207.99.54:8000",
  IMAGE_BASE_URL: "http://127.0.0.1:8000",

  // Google Maps Static API key — read from .env (REACT_APP_GOOGLE_MAPS_API_KEY).
  // Create React App only exposes env vars prefixed REACT_APP_, and only
  // ones set before `npm start`/`npm run build` — restart the dev server
  // after changing .env. Stays "" (Testing Mode) until the key is set.
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",

  ELECTRICAL_TAX_PERCENT: 18,
  ELECTRICAL_SURCHARGE_PERCENT: 5,

  CURRENCY_SYMBOL: "₹",


  TECHNICAL_SERVICE_CATEGORY: "technical",
  GARDENING_CATEGORY: "outdoor-services",
  OUTDOOR_SERVICE: "outdoor-services",
  PAINTING_CATEGORY: "home-services",
  GARDENING_SERVICE: "gardening-service",
  PAINTING_SERVICE: "painting-service",

		INSURANCE_SERVICE_CATEGORY : "insurance-services",

		VEHICLE_INSURANCE_SERVICE : "vehicle-insurance",
	LIFE_INSURANCE_SERVICE : "life-insurance",

  CARE_SERVICE_CATEGORY: "care-services",
  HOME_SERVICE_CATEGORY: "home-services",
  HOME_SERVICES_CATEGORY: "home-services",
  TRANSPORT_SERVICE_CATEGORY: "transport-services",
  PACKERS_MOVERS_CATEGORY: "packers-and-movers",

  AC_SERVICE: "ac-repair",
  ELECTRICAL_SERVICE: "electrical-services",
  PLUMBER_SERVICE: "plumber-services",
  PACKERS_MOVERS: "packers-and-movers",

  BABY_CARE_SERVICE: "baby-caretaker",
  ELDER_CARE_SERVICE: "elder-caretaker",
  PATIENT_CARE_SERVICE: "patient-caretaker",

  COOKING_SERVICE: "cooking",
  HOUSE_KEEPING_SERVICE: "house-keeping",
  KITCHEN_ROOM_CLEANING: "kitchen-room-cleaning",
  BATHROOM_CLEANING_SERVICE: "bathroom-cleaning",
  

  DRINKING_WATER_SERVICE: "drinking-water-supply",

  SUMP_TANK_SERVICE: "sump-and-tank-cleaner",

  CAR_DRIVER_SERVICE: "cardriver",

  TRIGGER_BUFFER_TIME: 30,
  JOB_START_BUFFER_MINUTES: 30,
  DEFAULT_SERVICE_PRICE: PRICING.DEFAULT_SERVICE_PRICE,
  PAYMENT_CREATE_ORDER_URL: "/api/payment/create-order/",
  PAYMENT_VERIFY_URL: "/api/payment/verify-payment/",
  ENABLE_MOCK_PAYMENT: true,
  SCHEDULE_DAYS_LIMIT: 3,

  // ── Payment logic — values now live in src/config/pricing.js ─────────────
  PARTIAL_PAYMENT_THRESHOLD: PRICING.PARTIAL_PAYMENT_THRESHOLD,

  // ── Checkout charges — SummaryPage reads all values from here ────────────
  CHECKOUT_CHARGES: PRICING.CHECKOUT_CHARGES,

  // ── Technical Consultation charge — admin-editable via the backend's
  // consultation_fees config type, merged in by fetchRemoteConfig() below.
  // { default: 90, "<service_id>": <override> }
  CONSULTATION_FEES: { default: 90 },

  // ── Partner tip — optional, added on top of the bill before confirmation ──
  PARTNER_TIP: PRICING.PARTNER_TIP,

  ONLINE_PAYMENT_PAGE: "/OnlinePayment",
  PRIME_SUB_OPTION: "No",

  // Cancellation charge — % of order total, based on status when cancelled.
  // Live values override these from MongoDB via GET /api/order/config/
  // Status reference: 0=New (before accept), 1=Accepted, 2=Work Started
  CANCELLATION_CHARGES: PRICING.CANCELLATION_CHARGES,

  // Instant Booking cancellation charges — separate, steeper tiers. Live
  // values override these from MongoDB via GET /api/order/config/instant/
  INSTANT_CANCELLATION_CHARGES: PRICING.INSTANT_CANCELLATION_CHARGES,

  SLOT_START_HOUR: 6,
  SLOT_END_HOUR: 20,
  SLOT_DURATION_HOURS: 2,

  AREA_OPTIONS: {
	bengaluru: {
	  limit: 3,
	  areas: [
		"BTM Layout",
		"Jayanagar",
		"HSR Layout",
		"Indiranagar",
		"Marathahalli",
	  ],
	},
	mysuru: {
	  limit: 5,
	  areas: [
		"Vijayanagar",
		"Gokulam",
		"Hebbal",
		"Kuvempunagar",
		"Nazarbad",
		"Lakshmipuram",
	  ],
	},
	chennai: {
	  limit: 4,
	  areas: [
		"T Nagar",
		"Velachery",
		"Adyar",
		"Anna Nagar",
		"Porur",
		"Tambaram",
	  ],
	},
  },

  SERVICE_CONFIG: {
	...PRICING.SERVICE_CONFIG_CATALOG,

	
	"insurance-services": {
		label: "Insurance Services",
		services: {
			"life-insurance": {
				label: "Life Insurance",
				types: [
					{ value: "term-insurance", label: "Term Insurance" },
					{ value: "whole-life-insurance", label: "Whole Life Insurance" },
					{ value: "child-plan", label: "Child Plan" },
					{ value: "retirement-plan", label: "Retirement Plan" },
					{ value: "ulip-plan", label: "ULIP Plan" },
				],
				},

			"vehicle-insurance": {
				label: "vehicle Insurance",
				types: [
					{ value: "term-insurance", label: "Term Insurance" },
					{ value: "whole-life-insurance", label: "Whole Life Insurance" },
					{ value: "ulip", label: "ULIP" },
					{ value: "child-plan", label: "Child Plan" },
					{ value: "retirement-plan", label: "Retirement Plan" },
				],
				},
		},
		},

	// -- Special Services -- pricing now lives in src/config/pricing.js
	// (SPECIAL_SERVICES_PRICING). Admin-editable there -- change a number
	// and the relevant wizard picks it up on next load.
	"special-services": {
		label: "Special Services",
		services: PRICING.SPECIAL_SERVICES_PRICING,
	},
	},

  // ── Cities ────────────────────────────────────────────────────────────────
  // Cities currently live on the platform. Set active: false to hide a city.
  ACTIVE_CITIES: ["bengaluru", "mysuru"],

  CITIES: {
    bengaluru: { label: "Bangalore", state: "Karnataka", active: true },
    mysuru:    { label: "Mysore",    state: "Karnataka", active: true },
  },

  // ── Mysore auto-discount rule ────────────────────────────────────────────
  // Applied when a service value is NOT listed in PRICE_LIST.
  // getServicePrice() uses this automatically as the fallback for mysuru.
  MYSORE_DISCOUNT_RULE: PRICING.MYSORE_DISCOUNT_RULE,

  // ══════════════════════════════════════════════════════════════════════════
  // SERVICE STATUS — enable / disable any service from one place
  // ──────────────────────────────────────────────────────────────────────────
  // Set a service's value to false to disable it across the site.
  // Disabled services show "Service currently stopped — will get back to you"
  // and cannot be added to cart or booked.
  // Keys that are absent default to enabled (true).
  // ══════════════════════════════════════════════════════════════════════════
  SERVICE_STATUS: {

    // ── Home Services (hs-*) ─────────────────────────────────────────────
    "hs-1": true,   // Kitchen Cleaning
    "hs-2": true,   // Bathroom Cleaning
    "hs-4": true,   // Balcony Cleaning
    "hs-9": true,   // Window & Glass Cleaning
    "hs-10": true,  // Packing & Unpacking
    "hs-11": true,  // Instant Special (bundled Kitchen/Bathroom/Living Room/Glass/Balcony)

    // ── Home Services — Sub-services ─────────────────────────────────────
    // hs-1 Kitchen Cleaning
    "hs-1-mopping":           true,
    "hs-1-utensils-cleaning": true,
    "hs-1-stove-cleaning":    false,
    "hs-1-slab-cleaning":     true,
    "hs-1-chimney-cleaning":  true,
    // hs-2 Bathroom Cleaning
    "hs-2-floor-tile-scrubbing":     true,
    "hs-2-toilet-deep-cleaning":     true,
    "hs-2-washbasin-cleaning":       true,
    "hs-2-mirror-fittings-cleaning": true,
    "hs-2-exhaust-fan-cleaning":     true,
    // hs-4 Balcony Cleaning
    "hs-4-floor-sweep-mop":      true,
    "hs-4-railing-cleaning":     true,
    "hs-4-corner-edge-cleaning": true,
    "hs-4-grille-wipedown":      true,
    "hs-4-plant-area-tidying":   true,
    // hs-9 Window & Glass Cleaning
    "hs-9-glass-pane-cleaning":  true,
    "hs-9-frame-track-cleaning": true,
    "hs-9-mesh-cleaning":        true,
    "hs-9-sill-cleaning":        true,
    "hs-9-grille-dust-removal":  true,
    // hs-10 Packing & Unpacking
    "hs-10-packing":                true,
    "hs-10-unpacking-placement":    true,
    "hs-10-box-labeling":           true,
    "hs-10-fragile-item-handling":  true,

    // ── Technical Services (tech-*) ───────────────────────────────────────
    "tech-1": true, // Plumbing Service
    "tech-2": true, // Electrical Service
    "tech-3": true, // AC Service
    "tech-4": true, // Carpenter Service
    "tech-5": true, // Painting Service
    "tech-6": true, // CCTV Installation
    "tech-7": true, // Fridge Repair
    "tech-8": true, // Washing Machine Repair
    "tech-9": true, // Pest Control

    // ── Outdoor Services (os-*) ───────────────────────────────────────────
    "os-1": true,   // Gardening Service
    "os-2": true,   // Lawn Mowing
    "os-3": true,   // Outdoor Cleaning
    "os-4": true,   // Tree Trimming
    "os-6": true,   // Car Wash at Home
    "os-7": true,   // Tank Cleaning
    "os-9": true,   // Pressure Wash Service

    // ── Caretaker Services (cs-*) ─────────────────────────────────────────
    "cs-1": true,   // Baby Care
    "cs-2": true,   // Elder Care
    "cs-3": true,   // Patient Care
    "cs-4": true,   // Postpartum Care
    "cs-5": true,   // Disabled Care Support
    "cs-6": true,   // Night Attendant
    "cs-7": true,   // Companion Care
    "cs-8": true,   // Hospital Attender
    "cs-9": true,   // Home Nursing Support

    // ── Transport Services (numeric string IDs) ───────────────────────────
    "1": true,  // Packers & Movers
    "2": true,  // Mini Truck Rental
    "3": true,  // Office Relocation
    "4": true,  // Furniture Shifting
    "5": true,  // Bike Transport
    "6": true,  // Car Transport
    "7": true,  // Parcel Delivery
    "8": true,  // Luggage Shifting
    "9": true,  // Appliance Transport

    // ── Special Services (ss-*) ────────────────────────────────────────────
    // Prefixed (not bare numeric like Transport above) since SpecialServices.js's
    // own listing ids (1,2,4,5,6 — see SPECIAL_SERVICES_LISTING) would otherwise
    // collide with Transport's bare "1"-"9" keys in this same flat map.
    "ss-1": true,  // Rapid Home Cleaning
    "ss-2": true,  // Deep Cleaning
    "ss-4": true,  // Move-in / Move-out Cleaning
    "ss-5": true,  // Kitchen & Utensil Cleaning
    "ss-6": true,  // Balcony, Terrace & Parking Area Cleaning
    "ss-7": true,  // Bedroom and Wardrobe Cleaning
  },

  // ══════════════════════════════════════════════════════════════════════════
  // PRICE LIST — single source of truth for all service pricing
  // ──────────────────────────────────────────────────────────────────────────
  // Format: "service-value": { base: ₹, mysuru: ₹, bengaluru: ₹, <city>: ₹ }
  //
  //   base      — default price used when a city has no explicit entry
  //   mysuru    — Mysore city price
  //   bengaluru — Bangalore city price
  //
  // To add a new city: add its key to the relevant entries and to CITIES.
  // To change a price: edit the city value here — nowhere else.
  // Services with uniform pricing across all cities only need `base`.
  // ══════════════════════════════════════════════════════════════════════════
  PRICE_LIST: PRICING.PRICE_LIST,

  // ── Membership plan pricing + GST overrides ──────────────────────────────
  // Admin-editable from the Dashboard's Seat Availability tab ("Membership
  // Plan Pricing & GST" card). Empty until fetchRemoteConfig() merges live
  // overrides in — see getMembershipPricing() below.
  MEMBERSHIP_PRICING: {},

  // ── Rapid Cleaning service-type x duration price overrides ───────────────
  // Admin-editable from the Dashboard's "Enable and Disable Option" tab
  // ("Rapid Home Cleaning — Service & Duration Pricing" card). Empty until
  // fetchRemoteConfig() merges live overrides in — see
  // getRapidCleaningPrice() below.
  RAPID_CLEANING_PRICING: {},
};

// ── City price helpers ────────────────────────────────────────────────────────

// Applies the Mysore auto-discount rule to an unknown base price.
// Used only as a fallback when a service is NOT listed in PRICE_LIST.
// base < ₹1,000 → base − 50 | base ≥ ₹1,000 → base − 100
export const autoMysorePrice = (base) => {
  if (typeof base !== "number") return base ?? 0;
  const rule = config.MYSORE_DISCOUNT_RULE || { below1000: 50, above1000: 100 };
  const deduct = base >= 1000 ? rule.above1000 : rule.below1000;
  return Math.max(0, base - deduct);
};

// Returns the city-specific price for a service.
// Lookup order:
//   1. PRICE_LIST[service][city]   — explicit city price (preferred)
//   2. PRICE_LIST[service].base    — service's own base price for unlisted cities
//   3. autoMysorePrice(basePrice)  — auto-discount fallback for mysuru (unlisted services)
//   4. basePrice                   — raw fallback for all other cases
//
// Usage:  getServicePrice("mopping", 1500, "bengaluru")  → 1800
//         getServicePrice("mopping", 1500, "mysuru")     → 1400
//         getServicePrice("new-service", 800, "mysuru")  → 750  (auto-discount)
export const getServicePrice = (serviceValue, basePrice, cityKey) => {
  const city  = (cityKey || "").toLowerCase().trim().replace(/\s+/g, "");
  const entry = config.PRICE_LIST?.[serviceValue];
  if (entry) {
    if (typeof entry[city] === "number") return entry[city];   // explicit city price
    if (typeof entry.base  === "number") {
      // city not listed → apply auto-discount for mysuru, base for others
      return city === "mysuru" ? autoMysorePrice(entry.base) : entry.base;
    }
  }
  // Service not in PRICE_LIST — fall back to caller-supplied basePrice
  if (city === "mysuru") return autoMysorePrice(basePrice);
  return basePrice ?? 0;
};

// Returns { taxPercent, platformFee } for a service, reading its optional
// per-service override from PRICE_LIST[serviceId].tax_percent/platform_fee
// (set from the Dashboard's Enable/Disable table — same entries as region
// pricing). Falls back to the global CHECKOUT_CHARGES default (Seat
// Availability tab's "Checkout Fees" card) for any service with no
// override, or that isn't in PRICE_LIST at all — mirrors getServicePrice()'s
// own fallback structure.
export const getServiceFees = (serviceId) => {
  const entry   = config.PRICE_LIST?.[serviceId];
  const globals = config.CHECKOUT_CHARGES ?? {};
  return {
    taxPercent:  typeof entry?.tax_percent  === "number" ? entry.tax_percent  : (globals.GST_PERCENT  ?? 0),
    platformFee: typeof entry?.platform_fee === "number" ? entry.platform_fee : (globals.PLATFORM_FEE ?? 0),
  };
};

// Returns { price, gstPercent } for a membership plan tier, reading its
// optional admin override from MEMBERSHIP_PRICING[planId] (set from the
// Dashboard's "Membership Plan Pricing & GST" card — see fetchRemoteConfig()
// below). Falls back to `fallbackPrice` (the hardcoded pricing.js default)
// when there's no price override, and to 18 when there's no GST% override —
// mirrors getServiceFees()'s override-or-fallback shape exactly. gstPercent
// is informational only (already baked into the price), not an extra charge.
export const getMembershipPricing = (planId, tierKey, fallbackPrice) => {
  const entry = config.MEMBERSHIP_PRICING?.[planId];
  const overridePrice = entry?.prices?.[tierKey];
  return {
    price:      typeof overridePrice === "number" ? overridePrice : fallbackPrice,
    gstPercent: typeof entry?.gst_percent === "number" ? entry.gst_percent : 18,
  };
};

// Returns the price for a Rapid Cleaning service type + duration combo,
// reading its optional admin override from RAPID_CLEANING_PRICING[serviceTypeId]
// (set from the Dashboard's "Rapid Home Cleaning — Service & Duration
// Pricing" card — see fetchRemoteConfig() below). Falls back to
// `fallbackPrice` (the hardcoded pricing.js pricesByDuration default) when
// there's no override — mirrors getMembershipPricing()'s override-or-fallback
// shape exactly.
export const getRapidCleaningPrice = (serviceTypeId, durationKey, fallbackPrice) => {
  const overridePrice = config.RAPID_CLEANING_PRICING?.[serviceTypeId]?.prices?.[durationKey];
  return typeof overridePrice === "number" ? overridePrice : fallbackPrice;
};

// Returns the city stored in localStorage, defaulting to mysuru.
export const getUserCity = () => {
  try { return localStorage.getItem("selectedCity") || "mysuru"; }
  catch { return "mysuru"; }
};

// Saves the user's city choice to localStorage.
export const setUserCity = (cityKey) => {
  try { localStorage.setItem("selectedCity", cityKey.toLowerCase()); }
  catch { /* noop */ }
};

// Returns false if the service is explicitly disabled in SERVICE_STATUS.
// Absent keys default to true (enabled).
export const isServiceEnabled = (serviceId) => {
  const status = config.SERVICE_STATUS;
  if (!status) return true;
  const key = String(serviceId);
  return key in status ? Boolean(status[key]) : true;
};

// ── Remote config sync ────────────────────────────────────────────────────────
// Merges area_options, price_list, service_status and checkout_fees from
// MongoDB over local defaults. Auto-triggered once on first import via the
// side-effect at the bottom. On network failure, local hardcoded values stay
// in effect.
// service_status is written by the K2Karmika-Dashboard "Enable and Disable
// Option" tab — an admin toggling a service there reaches every page that
// calls isServiceEnabled() on next load, no rebuild/redeploy needed.
// checkout_fees (Tax %/Platform Fee ₹) is written by the "Seat Availability"
// tab's "Checkout Fees" card, merged onto CHECKOUT_CHARGES.GST_PERCENT /
// PLATFORM_FEE — read by ScheduleSummaryPage.js's total calculation.

let _remoteConfigFetched = false;

export const fetchRemoteConfig = async () => {
  if (_remoteConfigFetched) return;
  try {
    const res  = await fetch(`${config.API_BASE_URL}/api/config/`);
    if (!res.ok) return;
    const data = await res.json();
    if (data.area_options && typeof data.area_options === "object") {
      config.AREA_OPTIONS = { ...config.AREA_OPTIONS, ...data.area_options };
    }
    if (data.price_list && typeof data.price_list === "object") {
      config.PRICE_LIST = { ...config.PRICE_LIST, ...data.price_list };
    }
    if (data.service_status && typeof data.service_status === "object") {
      config.SERVICE_STATUS = { ...config.SERVICE_STATUS, ...data.service_status };
    }
    if (data.checkout_fees && typeof data.checkout_fees === "object") {
      const fees = data.checkout_fees;
      config.CHECKOUT_CHARGES = {
        ...config.CHECKOUT_CHARGES,
        ...(typeof fees.tax_percent  === "number" ? { GST_PERCENT: fees.tax_percent } : {}),
        ...(typeof fees.platform_fee === "number" ? { PLATFORM_FEE: fees.platform_fee } : {}),
      };
    }
    if (data.membership_pricing && typeof data.membership_pricing === "object") {
      config.MEMBERSHIP_PRICING = { ...config.MEMBERSHIP_PRICING, ...data.membership_pricing };
    }
    if (data.consultation_fees && typeof data.consultation_fees === "object") {
      config.CONSULTATION_FEES = { ...config.CONSULTATION_FEES, ...data.consultation_fees };
    }
    if (data.rapid_cleaning_pricing && typeof data.rapid_cleaning_pricing === "object") {
      config.RAPID_CLEANING_PRICING = { ...config.RAPID_CLEANING_PRICING, ...data.rapid_cleaning_pricing };
    }
    _remoteConfigFetched = true;
  } catch {
    // Network failure — silently fall back to local defaults
  }
};

// Auto-fetch on first import (browser only). No need to call this from App.js.
if (typeof window !== "undefined") {
  setTimeout(fetchRemoteConfig, 0);
}

export default config;
